import { autorun, observable, action, computed } from 'mobx'
import client from '../../../helpers/client'
import { asNormalizedMaps, asNormalizedArrays } from '../../../helpers/json-normalizer'

class Store {
  @observable ready = false
  @observable loading = true
  @observable franchise
  @observable employees = []

  constructor({ widgetStore }) {
    this.widgetStore = widgetStore
    this.host = widgetStore.host
  }

  async setup() {
    this.loading = true
    await this.loadFranchise()
    await this.loadStaff()
    this.ready = true
    this.loading = false
  }

  loadFranchise() {
    return client.get(`${this.host}/api/v1/franchise`)
      .then(response => {
        const data = asNormalizedArrays(response.data)
        this.franchise = Object.values(data.franchise)[0]
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  loadStaff() {
    return client.get(`${this.host}/api/v1/employees`)
      .then(response => {
        const data = asNormalizedMaps(response.data)
        if(data.employee) {
          this.employees = Array.from(data.employee.values())
            .sort((a, b) => a.attributes.name.localeCompare(b.attributes.name))
        }
        else {
          this.employees = []
        }
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }
}

export default Store
